import { graphql } from 'gatsby';
import React from 'react';
import aboutNavData from '../../../site-data/about-page/aboutNav';
import {
	Alert,
	backgroundColor,
	backgroundGradient,
	textColor,
} from '../../../site-data/home/alert';
import AboutNav from '../../components/AboutPage/AboutNav';
import DismissableBanner from '../../components/DismissableBanner';
import Layout from '../../components/Layout';
import SEO from '../../components/SEO';
import MainNavigation from '../../components/MainNavigation';
import data from '../../../form-data';
import Hero from '../../components/wishlist/Hero';
import Campaigns from '../../components/wishlist/Campaigns';
import Tutorials from '../../components/wishlist/Tutorials';
import FeaturedLinks from '../../components/wishlist/FeaturedLinks';
import MainFooter from '../../components/MainFooter';
import heroData from '../../../site-data/wishlist/hero';
import campaignsData from '../../../site-data/wishlist/campaigns';
import { ReactComponent as WishlistLogo } from '../../svgs/nav/wishlist-logo.svg';
import tutorialsData from '../../../site-data/wishlist/tutorials';
import featuredLinksData from '../../../site-data/wishlist/featured-links';

const CommunityPage = props => {
	return (
		<Layout {...props} hasFooter={false} banner={data.banner} fullWidth>
			<SEO
				title="Create Your Dream Wishlist & Get Harrods Hampers Gifted!"
				description="Let PayPal and Amazon shoppers securely support your freelance work by shipping you luxury Harrods Hampers!"
			/>
			<DismissableBanner
				backgroundColor={backgroundColor}
				textColor={textColor}
				backgroundGradient={backgroundGradient}
			>
				{Alert === null ? null : <Alert />}
			</DismissableBanner>
			<AboutNav
				fullWidth
				navTitle={<WishlistLogo />}
				navLinks={aboutNavData.navLinks}
				btnText={aboutNavData.btnText}
				btnLink={aboutNavData.btnLink}
			/>
			<Hero
				title={heroData.title}
				subtitle={heroData.subtitle}
				heroImageDesktop={heroData.heroImageDesktop}
				heroImageMobile={heroData.heroImageMobile}
				btnText={heroData.btnText}
				btnLink={heroData.btnLink}
			/>
			<Campaigns campaigns={campaignsData} />
			<Tutorials tutorials={tutorialsData} />
			<FeaturedLinks
				communityFeatured={featuredLinksData.communityFeatured}
				productsFeatured={featuredLinksData.productsFeatured}
			/>
			<MainFooter />
		</Layout>
	);
};

export const pageQuery = graphql`
	query {
		site {
			siteMetadata {
				title
				nav {
					path
					icon
					title
					desc
				}
			}
		}
	}
`;
export default CommunityPage;
